module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_chap"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("German")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_vm._v("a) Listed in order of unit size")]), _vm._v(" "), _c('table', {
    staticClass: "table0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AG")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("army group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("A")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Pz A")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("panzer army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AC")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("army corps")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MotC")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized corps")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ID")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("infantry division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("PzD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("panzer division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MotD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CavD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("cavalry division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MtnD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("mountain division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Sec. D")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("security division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("IB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("infantry brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("PzB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("panzer brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("IR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("infantry regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("PzR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("panzer regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("EngR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("engineer regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MotR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MtrcR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorcycle regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Bn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("EngBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("engineer battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Co")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("company")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Btry")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("battery")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_vm._v("b) Listed alphabetically by abbreviation")]), _vm._v(" "), _c('table', {
    staticClass: "table0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("A")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AC")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("army corps")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AG")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("army group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Bn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Btry")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("battery")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CavD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("cavalry division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Co")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("company")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("EngBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("engineer battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("EngR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("engineer regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("IB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("infantry brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ID")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("infantry division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("IR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("infantry regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MotC")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized corps")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MotD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MotR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MtnD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("mountain division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MtrcR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorcycle regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Pz")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("A panzer army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("PzB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("panzer brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("PzD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("panzer division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("PzR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("panzer regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Sec. D")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("security division")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_vm._v("Soviet")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_vm._v("a) Listed in order of unit size")]), _vm._v(" "), _c('table', {
    staticClass: "table0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("A")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MC")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("mechanized corps")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RC")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle corps")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CG")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("cavalry group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("TD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("tank division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MRD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized rifle division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("cavalry division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("DNO")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("People’s militia division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("BAD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("bomber aviation division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FAD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("fighter aviation division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MAD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("mixed aviation division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("TB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("tank brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MRB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized rifle brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("fortified region")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ATR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("antitank artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CAR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("corps artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("GAR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("gun artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("HAR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("howitzer artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MtrR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("mortar regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("TR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("tank regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MRR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized rifle regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("cavalry regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RAS")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("reconnaissance aviation squadron")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("TBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("tank battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AABn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("antiaircraft artillery battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ATBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("antitank battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AutoBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("automobile battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("BEPO")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("armored train")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Bn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Co")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("company")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Btry")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("battery")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Gds.")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("guards")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Sep.")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("separate")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("G (as a prefix with any abbrev.)      guards")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_vm._v("b) Listed alphabetically by abbreviation")]), _vm._v(" "), _c('table', {
    staticClass: "table0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("A")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AABn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("antiaircraft artillery battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ATBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("antitank battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("ATR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("antitank artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("AutoBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("automobile battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("BAD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("bomber aviation division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("BEPO")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("armored train")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Bn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Btry")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("battery")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CAR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("corps artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("cavalry division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CG")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("cavalry group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Co")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("company")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("CR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("cavalry regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("DNO")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("People’s Militia division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FAD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("fighter aviation division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("FR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("fortified region")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("G (as a prefix with any abbrev.)      guards")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("GAR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("gun artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Gds.")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("guards")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("HAR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("howitzer artillery regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MAD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("mixed aviation division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MC")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("mechanized corps")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MRB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized rifle brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MRD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized rifle division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MRR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("motorized rifle regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("MtrR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("mortar regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RAS")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("reconnaissance aviation squadron")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RC")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle corps")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("RR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("rifle regiment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("Sep.")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("separate")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("TB")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("tank brigade")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("TBn")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("tank battalion")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("TD")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("tank division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_vm._v("TR")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("tank regiment")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11a5bbac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Abbreviations.vue
// module id = 81
// module chunks = 0